import React from 'react'
import { FaSpinner } from 'react-icons/fa'

function Loader() {
    return (
        <FaSpinner className="animate-spin text-2xl text-white mr-2" />)
}

export default Loader